var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRecruitNotice32Filled = function SvgIconRecruitNotice32Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.853 13.82a1.147 1.147 0 1 1 2.293 0 1.147 1.147 0 0 1-2.293 0Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.734 6.2A3.533 3.533 0 0 0 6.2 9.733v12.534A3.533 3.533 0 0 0 9.734 25.8h12.533a3.533 3.533 0 0 0 3.533-3.533V9.733A3.533 3.533 0 0 0 22.267 6.2H9.734ZM16 10.673a3.147 3.147 0 1 0 0 6.294 3.147 3.147 0 0 0 0-6.294ZM13 18.5a2.283 2.283 0 0 0-2.287 2.287v1.933h2v-1.933c0-.161.126-.287.287-.287h6.007c.16 0 .286.126.286.287v1.933h2v-1.933a2.283 2.283 0 0 0-2.286-2.287H13Z",
    fill: "current"
  })));
};
export default SvgIconRecruitNotice32Filled;